// import Container from "../common/_container";
import Container from "../../common/_container"
import "../../../assets/styles/basic-details.scss";
import "../../../assets/styles/payment.scss";
// import RejectedIcon from "../../assets/images/journeyIcons/AD/10/21/381636_block_icon.png";
 
 
 
 
export default function LeadCaptureSuccess({ ...props }) {
 
 
  return (
    <Container name="error">
      <div className="basic-details payment-details failure-page">
        <div className="wrapper">
          <section className="card-layout">
            <div className="grid" md={12}>
              <div className="content" style={{marginTop:"20px"}}>
                <div className="content-card text-center static-card">
                  <div className="row">
                    <div className="row">
                      {/* <img src={RejectedIcon} alt="Payment Failed" /> */}
                    </div>
                    <div className="big-text---navy-blue text-capitalise">
                    </div>
 
                    <div className="big-text---navy-blue text-capitalise">
                    Thank you for showing your interest, Our Sales representative will connect with you Soon.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </Container>
  );
}
 
 